const Denied = () => import(/* webpackChunkName: 'DeniedPage'*/ '@/views/denied/denied');
const DeniedSection = () => import(/* webpackChunkName: 'DeniedSectionPage'*/ '@/views/denied-section/denied-section');
const DeniedInstitute = () => import(/* webpackChunkName: 'DeniedInstitutePage'*/ '@/views/denied-institute/denied-institute');
const HomeController = () => import(/* webpackChunkName: 'HomeControllerPage'*/ '@/views/home-controller/home-controller');
const HomeBooks = () => import(/* webpackChunkName: 'HomeBooks'*/ '@/views/home-books/home-books');
const HomeFeatured = () => import(/* webpackChunkName: 'HomeFeatured'*/ '@/views/home-featured/home-featured');
const HomeGenres = () => import(/* webpackChunkName: 'HomeGenres'*/ '@/views/home-genres/home-genres');
const Search = () => import(/* webpackChunkName: 'Search'*/ '@/views/search/search');
const SearchResults = () => import(/* webpackChunkName: 'SearchResults'*/ '@/views/search-results/search-results');
const Bookmarks = () => import(/* webpackChunkName: 'Bookmarks'*/ '@/views/bookmarks/bookmarks');
const Category = () => import(/* webpackChunkName: 'CategoryPage'*/ '@/views/category/category');
const CategoryClass = () => import(/* webpackChunkName: 'CategoryClassPage'*/ '@/views/category-class/category-class');
const CategoryClassic = () => import(/* webpackChunkName: 'CategoryClassicPage'*/ '@/views/category-classic/category-classic');
const CategoryFiction = () => import(/* webpackChunkName: 'CategoryFictionPage'*/ '@/views/category-fiction/category-fiction');
const Intro = () => import(/* webpackChunkName: 'IntroPage'*/ '@/views/intro/intro');
const Login = () => import(/* webpackChunkName: 'LoginPage'*/ '@/views/login/login');
const ProfileController = () => import(/* webpackChunkName: 'ProfileControllerPage'*/ '@/views/profile-controller/profile-controller');
const Profile = () => import(/* webpackChunkName: 'ProfilePage'*/ '@/views/profile/profile');
const ProfileEdit = () => import(/* webpackChunkName: 'ProfileEditPage'*/ '@/views/profile-edit/profile-edit');
const BookDetails = () => import(/* webpackChunkName: 'BookDetailsPage'*/ '@/views/book-details/book-details');
const BookReviews = () => import(/* webpackChunkName: 'BookReviewsPage'*/ '@/views/book-reviews/book-reviews');
const BookComment = () => import(/* webpackChunkName: 'BookCommentPage'*/ '@/views/book-comment/book-comment');
const BookCommentUpdate = () => import(/* webpackChunkName: 'BookCommentUpdatePage'*/ '@/views/book-comment-update/book-comment-update');
const BookDescription = () => import(/* webpackChunkName: 'BookDescriptionPage'*/ '@/views/book-description/book-description');
const Preferred = () => import(/* webpackChunkName: 'Preferred'*/ '@/views/preferred/preferred');
const Shared = () => import(/* webpackChunkName: 'Shared'*/ '@/views/shared/shared');

export default [
    {
        path: '/',
        name: 'intro',
        component: Intro,
        meta: {
            hideLayout: true
        }
    },
    {
        path: '/home',
        name: 'home',
        component: HomeController,
        meta: {
            title: '',
            requiresAuth: true
        },
        children: [
            {
                path: '/home',
                name: 'home-books',
                component: HomeBooks,
            },
            {
                path: '/featured',
                name: 'home-featured',
                component: HomeFeatured,
            },
            {
                path: '/genres',
                name: 'home-genres',
                component: HomeGenres,
            }
        ]
    },
    {
        path: '/search',
        name: 'search',
        component: Search,
        meta: {
            showBack: true,
            title: 'Cerca un libro',
            requiresAuth: true
        }
    },
    {
        path: '/search-results',
        name: 'search-results',
        component: SearchResults,
        meta: {
            showBack: true,
            title: 'Risultati ricerca',
            requiresAuth: true
        }
    },
    {
        path: '/bookmarks',
        name: 'bookmarks',
        component: Bookmarks,
        meta: {
            showBack: true,
            title: 'La mie letture',
            requiresAuth: true
        }
    },
    {
        path: '/preferred',
        name: 'preferred',
        component: Preferred,
        meta: {
            showBack: true,
            title: 'I libri da leggere',
            requiresAuth: true
        }
    },
    {
        path: '/shared',
        name: 'shared',
        component: Shared,
        meta: {
            showBack: true,
            title: 'Libri Condivisi con Te',
            requiresAuth: true
        }
    },
    {
        path: '/category/:id',
        name: 'category',
        component: Category,
        meta: {
            showBack: true,
            title: 'Categorie',
            requiresAuth: true
        }
    },
    {
        path: '/category-class',
        name: 'category-class',
        component: CategoryClass,
        meta: {
            showBack: true,
            title: 'Più letti dalla Classe',
            requiresAuth: true
        }
    },
    {
        path: '/category-classic',
        name: 'category-classic',
        component: CategoryClassic,
        meta: {
            showBack: true,
            title: 'Letteratura classica',
            requiresAuth: true
        }
    },
    {
        path: '/category-fiction',
        name: 'category-fiction',
        component: CategoryFiction,
        meta: {
            showBack: true,
            title: 'Narrativa internazionale',
            requiresAuth: true
        }
    },
    {
        path: '/profile',
        name: 'profile-controller',
        component: ProfileController,
        children: [
            {
                path: '/profile',
                name: 'profile',
                component: Profile,
                meta: {
                    showBack: true,
                    title: 'Il mio profilo',
                    requiresAuth: true
                }
            },
            {
                path: '/profile/edit',
                name: 'profile-edit',
                component: ProfileEdit,
                meta: {
                    showBack: true,
                    title: 'Modifica profilo',
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/book/:id',
        name: 'book-details',
        component: BookDetails,
        meta: {
            showBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/book/:id/reviews',
        name: 'book-reviews',
        component: BookReviews,
        meta: {
            showBack: false,
            requiresAuth: true
        }
    },
    {
        path: '/book/:id/comment',
        name: 'book-comment',
        component: BookComment,
        meta: {
            showBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/book/:id/comment/update',
        name: 'book-comment-update',
        component: BookCommentUpdate,
        meta: {
            showBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/book/:id/description',
        name: 'book-description',
        component: BookDescription,
        meta: {
            showBack: true,
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            hideLayout: true
        }
    },
    {
        path: '/denied',
        name: 'denied',
        component: Denied,
        meta: {
            hideLayout: true
        }
    },
    {
        path: '/denied-section',
        name: 'denied-section',
        component: DeniedSection,
        meta: {
            hideLayout: true
        }
    },
    {
        path: '/denied-institute',
        name: 'denied-institute',
        component: DeniedInstitute,
        meta: {
            hideLayout: true
        }
    },
]
